/*global moment*/
(function (module) {
    'use strict';

    module.directive('duration', function () {
        return {
            scope: {
                duration: '='
            },
            link: function (scope, element) {
                var now = moment(scope.duration).fromNow();
                element.text(now);
            }
        };
    });
}(angular.module('emarket.commons')));
